import { render, staticRenderFns } from "./cis_business.vue?vue&type=template&id=1938235e&scoped=true"
import script from "./cis_business.vue?vue&type=script&lang=js"
export * from "./cis_business.vue?vue&type=script&lang=js"
import style0 from "./cis_business.vue?vue&type=style&index=0&id=1938235e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1938235e",
  null
  
)

export default component.exports